import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useVenue } from "@queries/useVenue";
import { useVenueSessions } from "@queries/useVenueSessions";
import { AuthContext } from "@context/AuthContext";
import { PromoContext } from "@context/PromoContext";
import Loader from "@components/Ui/Loader";
import DateSelector from "@components/V3/DateSelector";
import VenueSessionList from "@components/V3/VenueDetails/VenueSessionList";
import "./style.scss";

const VenueSessionSelector = () => {
    const { id, venue_name } = useParams();
    const { user } = useContext(AuthContext);
    const { fetchApplyPromoAvailability } = useContext(PromoContext);
    const { venue } = useVenue(id, venue_name);
    const { sessionsByVenue, availableDates, isLoadingVenueSessions } = useVenueSessions(id);

    useEffect(() => {
        if (user?.id) {
            fetchApplyPromoAvailability();
        }
    }, [user?.id]);

    const [selectedDate, setSelectedDate] = useState(null);
    const [filteredSessions, setFilteredSessions] = useState({});

    useEffect(() => {
        if (availableDates.length > 0) {
            const firstDate = availableDates[0];
            setSelectedDate(firstDate);
            handleDateClick(firstDate);
        }
    }, [sessionsByVenue, availableDates]);

    const handleDateClick = (date) => {
        setSelectedDate(date);
        const filtered = sessionsByVenue[date];
        setFilteredSessions(filtered || {});
    };

    const hasAvailableDates = availableDates.length > 0;

    return (
        <>
            {isLoadingVenueSessions ? (
                <Loader isLoading={isLoadingVenueSessions} text="Fetching sessions" />
            ) : (
                <div className="venue-details">
                    {hasAvailableDates && (
                        <DateSelector
                            uniqueDates={availableDates}
                            handleClickDate={handleDateClick}
                            selectedDate={selectedDate}
                        />
                    )}
                    <VenueSessionList
                        selectedDate={selectedDate}
                        sessions={filteredSessions}
                        venue={venue}
                    />
                </div>
            )}
        </>
    );
};

export default VenueSessionSelector;
